import commonThemes from './common'

const defaulttheme = {
  ...commonThemes
}
export default defaulttheme
